import React from 'react';

type SvgQuestionMarkProps = {
  width?: number;
  height?: number;
};

const QuestionMarkCloud = ({ width = 40, height = 40 }: SvgQuestionMarkProps): JSX.Element => (
  <svg width={width} height={height} viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <title>Question Mark Icon</title>
    <g clipPath='url(#a)' stroke='#464F53' strokeWidth='2.5'>
      <path d='M20 28c-.552 0-1-.224-1-.5s.448-.5 1-.5M20 28c.552 0 1-.224 1-.5s-.448-.5-1-.5' />
      <path
        d='M15 17.5c0-.89.293-1.76.843-2.5a4.926 4.926 0 0 1 2.244-1.658 5.518 5.518 0 0 1 2.889-.256c.97.174 1.86.603 2.56 1.232.699.63 1.175 1.431 1.368 2.304a4.084 4.084 0 0 1-.285 2.6 4.637 4.637 0 0 1-1.841 2.02A5.403 5.403 0 0 1 20 22'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M38 20a6.002 6.002 0 0 0-4.189-5.721 5.999 5.999 0 0 0-8.089-8.09 6.002 6.002 0 0 0-11.443 0 6 6 0 0 0-8.09 8.09 6 6 0 0 0 0 11.442 6 6 0 0 0 8.09 8.09 6 6 0 0 0 11.443 0 5.999 5.999 0 0 0 8.09-8.09A6.002 6.002 0 0 0 38 20Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
    <defs>
      <clipPath id='a'>
        <path fill='#fff' d='M0 0h40v40H0z' />
      </clipPath>
    </defs>
  </svg>
);

export default QuestionMarkCloud;
